export const en = {
  'app.components.dashboard.title': 'Dashboard',
  'app.components.order-selector.title': 'Show open orders:',
  'app.components.order-selector.today': 'Today',
  'app.components.order-selector.tomorrow': 'Tomorrow',
  'app.components.order-selector.later': 'Later',
  'app.components.hamburger-menu.title': 'Active Orders',
  'app.components.hamburger-menu.aria-label': 'Menu',
  'app.components.search-button.aria-label': 'Search button',
  'app.components.product-item-controls.accept': 'Accept',
  'app.components.product-control-switcher.switch-product-control': 'Switch product control',
  'app.components.simple-cycle.labels': `{labels, number} {labels, plural,
    one {Label}
    other {Labels}
  }`,
  'app.components.simple-cycle.orders': `{orders, number} {orders, plural,
    one {Open order}
    other {Open orders}
  }`,
  'app.components.simple-cycle.today': '{date}, Today',
  'app.components.cycle-header.today': '{date}, Today',
  'app.components.cycle-header.count': `{ count, number } {count, plural,
    one { order }
    other { orders}
  }`,
  'app.components.cycle-header.label-items': 'Labeled items',
  'app.components.modal.close-button-aria-label': 'Close modal',
  'app.components.product-item-controls.print': 'Print',
  'app.components.cycle-order.consolidate': 'Consolidate',
  'app.components.order-consolidate-modal.consolidate': 'Consolidate',
  'app.components.order-consolidate-modal.button': 'Select the items you want to consolidate',
  'app.components.order-consolidate-modal.consolidate-items': `Consolidate { amount, number } { amount, plural,
    one { item }
    other { items }
  }`,
  'app.components.product-decline-form.title': 'Tell us the reason',
  'app.components.product-decline-form.form-button': 'Ok',
  'app.components.product-quantity-selector.question': 'How many can you deliver?',
  'app.components.product-quantity-selector.increase': 'Increase product quantity',
  'app.components.product-quantity-selector.decrease': 'Decrease product quantity',
  'app.components.product-quantity-selector.product-quantity': 'Product quantity',
  'app.components.change-order-status-button.move-ready-button': 'Move to ready',
  'app.components.change-order-status-button.remove-button': 'Remove from pallet',
  'app.components.change-order-status-button.to-in-progress-button': 'Move to in-progress',
  'app.components.change-order-status-button.reason': 'Moved to In-Progress',
  'app.components.product-modal.unpack': 'Unpack',
  'app.components.product-modal.print-label': 'Print',
  'app.components.product-modal.re-print-label': 'Re-print label',
  'app.components.product-modal.unpack-to-detach': 'Unpack to detach from order',
  'app.components.product-decline-button.decline': 'Decline',
  'app.components.product-decline-button.tooltip': 'In order to Decline, you need to Unpack first',
  'app.components.cycle-modal.ok': 'OK',
  'app.components.got-it.text': 'Got it',
}
